import { Button, Stack } from "@mui/material";
import { useContactDrawer } from "components/Contact/useContactDrawer";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toggle_drawer } from "state/actions";
import { getFocus, useAtom, useGet } from "state/jotai";
import Unit from "./Unit.model";
import { active_project, previousUrl }       from "state/store.global";
import { _project } from "state/store.projects";
import { useLocation } from 'react-router-dom';

function DrawerCTA({ unit }) {
  const location = useLocation();

  const [, setPreviousUrl] = useAtom(previousUrl);
  const { open } = useContactDrawer();

  const navigateTo = useNavigate();

  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const {
    i18n: { language },
  } = useTranslation();
  const [, toggleDrawer] = useAtom(toggle_drawer);

  const handleMore = () => {
    // setPreviousUrl(location.pathname)
    // navigateTo(`/${language}/unit/${unit.getId()}`);
    // toggleDrawer();
    window.open(` https://juliliving.dk/tingbjerget-bolig?boligID=${unit.getId()}`, "_blank");
  };
 
  const handleContact = () => {
    open(unit);
  }

  // const searchUrl = `https://juliliving.dk/banehaverne-bolig/?boligID=${unit.getId()}`;


  return (
    <Stack clr={clr} direction="row" spacing="1px" justifyContent="center">
      {/* <Button  clr={clr} sx={{background:clr.buttons, color:clr.primary_text}} variant="contained" size="large" onClick={handleContact}>
        { buttonsLabel?.filter( btn => btn.UILabelProperty === 'Kontakt')[0]?.Label }
      </Button> */}
      {/* <a href={searchUrl} target="_blank" rel="noopener noreferrer"> */}
        <Button sx={{background:clr.button , color:clr.button_text}} variant="contained" size="large" onClick={handleMore}>
          { buttonsLabel?.filter( btn => btn.UILabelProperty === 'UnitExtButton')[0]?.Label }
        </Button>
      {/* </a>   */}
    </Stack>
  );
}

DrawerCTA.propTypes = {
  unit: PropTypes.instanceOf(Unit).isRequired,
};

export default DrawerCTA;
